import { useRef, useEffect } from "react";
import { MuuriComponent, useRefresh } from "muuri-react";
import { socialCardKeys } from "@/src/constants/socialcard.constant";

import GetEmbedCard from "@/src/components/wall-components/GetEmbedCard";
import scaleAwareLayout from "@/src/components/wall-components/scaleAwareLayout";

import GetReviewTestimonialCard from "@/src/components/wall-components/widgetTypes/star-review-card/GetReviewTestimonialCard";
import GetBannerReviewCard from "@/src/components/wall-components/widgetTypes/banner-review-card/GetBannerReviewCard";
import GetGraphicCard from "@/src/components/wall-components/widgetTypes/graphic-card/GetGraphicCard";
import GetCleanReviewCard from "@/src/components/wall-components/widgetTypes/clean-review-card/GetCleanReviewCard";
import GetAwardReviewCard from "@/src/components/wall-components/widgetTypes/award-review-card/GetAwardReviewCard";
import GetQuoteTextReviewCard from "@/src/components/wall-components/widgetTypes/quote-text-review-card/GetQuoteTextReviewCard";
import GetGreyColoredCard from "@/src/components/wall-components/widgetTypes/grey-colored-card/GetGreyColoredCard";
import { getStudioRenderer } from "@/src/components/wall-components/widgetTypes/studio-cards";
import { ReadMoreTextContext } from "@/src/components/componentHelper/ReadMoreReadLess";

import { wallKeys, WIDGET_TYPE } from "@/src/constants/wall.constant";

const MuuriGridComponent = ({
  cardItems,
  cardWidth,
  resizeStyleParams,
  wall,
}) => {
  let gridTimer = null;

  const gridRef = useRef();

       
  const refresh = (() => {
    let gridTimer = null;
    return () => {
      if (gridTimer) {
        clearTimeout(gridTimer);
      }
      gridTimer = setTimeout(() => {
        if (gridRef && gridRef.current) {
          gridRef.current.refreshItems();
          gridRef.current.layout();
        }
      }, 500);
    };
  })();

  useEffect(() => {
    return () => {
      clearTimeout(gridTimer);
    };
  }, []);

  const renderWidget = (widgetProps) => {
    /* Studio card set (types 10-19). One lookup instead of ten branches;
       returns null for every older type, which then falls through below. */
    const studioRenderer = getStudioRenderer(wall[wallKeys.widgetType]);
    if (studioRenderer) {
      return studioRenderer({ ...widgetProps });
    }

    if (wall[wallKeys.widgetType] === WIDGET_TYPE.CENTRE_REVIEW_TYPE) {
      return GetReviewTestimonialCard({ ...widgetProps });
    } else if (
      wall[wallKeys.widgetType] === WIDGET_TYPE.BIG_PICTURE_REVIEW_TYPE
    ) {
      return GetBannerReviewCard({ ...widgetProps });
    } else if (wall[wallKeys.widgetType] === WIDGET_TYPE.GRAPHIC_REVIEW_TYPE) {
      return GetGraphicCard({ ...widgetProps });
    } else if (wall[wallKeys.widgetType] === WIDGET_TYPE.QUOTE_REVIEW_TYPE) {
      return GetCleanReviewCard({ ...widgetProps });
    }  else if(wall[wallKeys.widgetType] === WIDGET_TYPE.QUOTE_TEXT_REVIEW_WIDGET_TYPE){
      return GetQuoteTextReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType] === WIDGET_TYPE.AWARD_WIDGET_TYPE){
      return GetAwardReviewCard({ ...widgetProps })
    }
    else if(wall[wallKeys.widgetType] === WIDGET_TYPE.GREY_COLORED_WIDGET_TYPE){
      return GetGreyColoredCard({ ...widgetProps })
    }
    else return GetEmbedCard({ ...widgetProps });
  };

  return (
    <MuuriComponent
      id={"famewall-embed-grid"}
      instantLayout={true}
      dragEnabled={false}
      layout={scaleAwareLayout}
      ref={gridRef}
    >
      {cardItems.map((cardItem) => (
        <div
          key={cardItem[socialCardKeys.uuid]}
          id={cardItem[socialCardKeys.uuid]}
          className={`item`}
          style={{ maxWidth: cardWidth, width: "100%", touchAction:'auto !important', ...resizeStyleParams }}
        >
          <div className="item-content" style={{ width: "100%" }}>
            <ReadMoreTextContext.Provider
              value={{
                readMoreText: wall[wallKeys.readMoreText],
                readLessText: wall[wallKeys.readLessText]
              }}
            >
              {renderWidget({
                socialCardType: cardItem[socialCardKeys.socialCardType],
                cardWidth: "100%",
                cardItem: cardItem,
                cardBackgroundObject: wall[wallKeys.cardBackgroundObject],
                darkModeEnabled: wall[wallKeys.isDarkModeEnabled],
                cardFontColor: wall[wallKeys.cardFontColor],
                linkColor: wall[wallKeys.linkColor],
                highlightColor: wall[wallKeys.highlightColor],
                darkCardTheme: wall[wallKeys.darkCardTheme],
                engagementDisabled: wall[wallKeys.isEngagementDisabled],
                smallSize: wall[wallKeys.isSmallSize],
                refresh: refresh,
                shortenText: wall[wallKeys.shortenText],
                isDateTimeDisabled: wall[wallKeys.isDateTimeDisabled],
                quotationColor: wall[wallKeys.quotationColor],
                bandColor: wall[wallKeys.bandColor],
                inkColor: wall[wallKeys.inkColor],
                scoreBlockColor: wall[wallKeys.scoreBlockColor],
                ratingColor: wall[wallKeys.ratingColor],
                fontStyle: wall[wallKeys.fontStyle]
              })}
            </ReadMoreTextContext.Provider>
          </div>
        </div>
      ))}
    </MuuriComponent>
  );
};

export default MuuriGridComponent;
